import { render, staticRenderFns } from "./EntityAssociation.vue?vue&type=template&id=5f130dc6&scoped=true&"
import script from "./EntityAssociation.vue?vue&type=script&lang=js&"
export * from "./EntityAssociation.vue?vue&type=script&lang=js&"
import style0 from "./EntityAssociation.vue?vue&type=style&index=0&id=5f130dc6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f130dc6",
  null
  
)

export default component.exports